type GroupByType = 'MONTH' | 'WEEK' | 'QUARTER';

const TIMELINE_STORAGE_KEY = 'signal_timeline_group_by';

export const getStoredGroupBy = (): GroupByType => {
  try {
    const stored = localStorage.getItem(TIMELINE_STORAGE_KEY);

    if (!stored) {
      return 'MONTH';
    }

    const groupBy = stored as GroupByType;

    // Validate the stored value
    if (groupBy === 'MONTH' || groupBy === 'WEEK' || groupBy === 'QUARTER') {
      return groupBy;
    }

    return 'MONTH';
  } catch {
    return 'MONTH';
  }
};

export const saveGroupBy = (groupBy: GroupByType): void => {
  try {
    localStorage.setItem(TIMELINE_STORAGE_KEY, groupBy);
  } catch {
    // Silently fail if localStorage is not available
  }
};
